import {
  FiLogIn, FiLogOut, FiThermometer, FiDroplet, FiTool, FiTruck,
  FiAlertTriangle, FiShield, FiUsers, FiZap, FiHome, FiUserCheck,
  FiPower, FiUser, FiFileText, FiMessageSquare, FiAward,
  FiCheckSquare, FiBookOpen, FiClipboard, FiCheckCircle, FiHelpCircle,
} from "react-icons/fi";

import {
  LuGlassWater, LuSparkles, LuBug, LuBox, LuTrash2, LuThermometer,
  LuLayers, LuTv, LuZap, LuCpu, LuSettings, LuUserCheck, LuBoxes,
} from "react-icons/lu";

import {
  FaThermometerHalf, FaBoxOpen, FaFireExtinguisher, FaBell,
  FaExclamationTriangle, FaGraduationCap, FaRunning,
} from "react-icons/fa";

import { IoFootstepsOutline, IoBulbOutline, IoFastFoodOutline } from "react-icons/io5";
import { MdStorefront, MdCleaningServices, MdOutlineFastfood } from "react-icons/md";
import { GiTable, GiForkKnifeSpoon } from "react-icons/gi";
import { BiUser, BiTrash } from "react-icons/bi";
import { TbTruckDelivery } from "react-icons/tb";
import { HiOutlineDocumentText } from "react-icons/hi2";

const iconMap = {
  FiLogIn, FiLogOut, FiThermometer, FiDroplet, FiTool, FiTruck,
  FiAlertTriangle, FiShield, FiUsers, FiZap, FiHome, FiUserCheck,
  FiPower, FiUser, FiFileText, FiMessageSquare, FiAward,
  FiCheckSquare, FiBookOpen, FiClipboard, FiCheckCircle,
  LuGlassWater, LuSparkles, LuBug, LuBox, LuTrash2, LuThermometer,
  LuLayers, LuTv, LuZap, LuCpu, LuSettings, LuUserCheck, LuBoxes,
  FaThermometerHalf, FaBoxOpen, FaFireExtinguisher, FaBell,
  FaExclamationTriangle, FaGraduationCap, FaRunning,
  IoFootstepsOutline, IoBulbOutline, IoFastFoodOutline,
  MdStorefront, MdCleaningServices, MdOutlineFastfood,
  GiTable, GiForkKnifeSpoon,
  BiUser, BiTrash,
  TbTruckDelivery,
  HiOutlineDocumentText,
};

export const DynamicIcon = ({ iconName, fallbackIconName, className = "text-indigo-600 w-4 h-4" }) => {
  const name = typeof iconName === 'string' ? iconName.trim() : '';
  const Icon = iconMap[name] || iconMap[fallbackIconName] || FiHelpCircle;
  return <Icon className={className} />;
};
